import { IonCol } from "@ionic/react";
import classNames from "classnames/bind";
import React from "react";
import { Product, ProductType } from "@core/types";
import { useCreatePriceMarkup } from "../../../../../utils/useCreatePriceMarkup";
import styles from "./NewListViewProduct.module.scss";

interface ProductPriceProps {
  product: Product;
}

const cx = classNames.bind(styles);

const ProductPrice = ({ product }: ProductPriceProps) => {
  const priceHtml = useCreatePriceMarkup(product);

  return product.stockQuantity > 0 || product.type === ProductType.VARIABLE ? (
    <IonCol sizeSm="9" className={cx("ion-no-padding", "productBasket__priceWrapper")}>
      <p className={cx("price ellipsis", styles.price, "productBasket__price")} dangerouslySetInnerHTML={priceHtml}></p>
    </IonCol>
  ) : null;
};

export default ProductPrice;
